module.exports = __webpack_public_path__ + "static/media/x-button.be846d74.png";